import React from 'react';
import styled from 'styled-components';
import CircleButtonWithArrow from '../CircleButtonWithArrow';
import Buttons from '../Slider/Buttons';
import CloseButton from '../CaseWithResize/FullSize/CloseButton';
import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import Slider from '../Slider';

class PopupWithImages extends Slider {
    constructor(props) {
        super(props);

        this.prevImage = this.prevImage.bind(this);
        this.nextImage = this.nextImage.bind(this);
        this.handleBgClose = this.handleBgClose.bind(this);
    }

    componentDidMount() {
        const { currentIndex = 0 } = this.props;
        this.setState({
            currentIndex,
        });
    }


    handleBgClose(event) {
        const { handleClosePopUp } = this.props;
        if ([...event.target.classList].indexOf('root-full-size-slider') !== -1) {
            handleClosePopUp();
        }
    }

    nextImage() {
        const { currentIndex } = this.state;
        this.changeIndex(currentIndex + 1);
    }

    prevImage() {
        const { currentIndex } = this.state;
        this.changeIndex(currentIndex - 1);
    }

    render() {
        const { currentIndex } = this.state;
        const { className, slides, handleClosePopUp } = this.props;

        return (
            <Root className={`root-full-size-slider ${className}`} onClick={this.handleBgClose}>
                <ImagesWrapper>
                    <>
                        {slides.map((slide, index) => (
                            <Img
                                key={index.toString()}
                                style={{ display: currentIndex === index ? 'block' : 'none' }}
                                src={slide}
                                onMouseDown={(e) => this.onPress(e.clientX)}
                                onMouseUp={(e) => this.onUp(e.clientX)}
                                onTouchStart={(e) => this.onPress(e.changedTouches[0].pageX)}
                                onTouchEnd={(e) => this.onUp(e.changedTouches[0].pageX)}
                            />
                        ))}
                    </>
                    <StyledButtons
                        quantity={slides.length}
                        currentIndex={currentIndex}
                        onClick={this.changeIndex}
                    />
                    {slides.length > 1 && (
                        <>
                            <ArrowButtonRight
                                isArrowRight
                                onClick={this.nextImage}
                            />
                            <ArrowButtonLeft onClick={this.prevImage} />
                        </>
                    )}
                </ImagesWrapper>
                <StyledCloseButton onClick={handleClosePopUp} />
            </Root>
        );
    }
}

const Root = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
`;

const ImagesWrapper = styled.div`
    width: 360px;
    height: 263px;
    position: relative;
    display: flex;
    justify-content: center;
    
    ${mediaWidth.m} {
        width: 768px;
        height: 564px;
    }
    
    ${mediaWidth.l} {
        width: 792px;
        height: 582px;
    }
    
    ${mediaWidth.xl} {
        width: 810px;
        height: 594px;
    }
`;

const Img = styled.img`
    width: 100%;
    height: 100%;
    position: relative;
`;

const ArrowButtonRight = styled(CircleButtonWithArrow)`
    position: absolute;
    top: calc(50% - 16px);
    right: 16px;
    opacity: 1;
    
    display: none;

    ${mediaWidth.l} {
        display: block;
        right: -52px;
    }
    
    ${mediaWidth.xl} {
        right: -236px;
    }
`;

const ArrowButtonLeft = styled(CircleButtonWithArrow)`
    position: absolute;
    top: calc(50% - 16px);
    left: 16px;
    opacity: 1;
    
    display: none;
    ${mediaWidth.l} {
        display: block;
        left: -52px;
    }
    
    ${mediaWidth.xl} {
        left: -236px;
    }
`;

const StyledButtons = styled(Buttons)`
    display: ${({ quantity }) => (quantity === 1 ? 'none' : '')};
    position: absolute;
    bottom: 0px;
    left: auto;
`;

const StyledCloseButton = styled(CloseButton)`
    position: absolute;
    top: 16px;
    right: 16px;
    
    & > .icon {
        stroke: white;
    }
    
    ${mediaWidth.m} {
        top: 24px;
        right: 24px;
    }
`;

export default PopupWithImages;
